import CheckBox from 'apollo-react/components/Checkbox';
import React from 'react';

import { getUITA } from '../../../utils/commonUtils';
import { BUILD_NUMBER_COLUMN } from '../../constants/runtime.constants';

const CompareBuildsCell = ({ row, column }) => {
  const { selectedBuilds, setSelectedBuilds } = column;
  const checked = selectedBuilds.some((build) => build.key === row.key);

  const changeHandler = ({ target: { checked } }) => {
    if (checked) {
      setSelectedBuilds((prev) => [
        ...prev,
        { buildNumber: row[BUILD_NUMBER_COLUMN], key: row.key },
      ]);
    } else {
      setSelectedBuilds((prev) => prev.filter((build) => build.key !== row.key));
    }
  };

  return (
    <CheckBox
      checked={checked}
      onChange={changeHandler}
      disabled={selectedBuilds.length === 2 && !checked}
      ui-ta={getUITA('Compare Builds Checkbox', row.index)}
    />
  );
};

export default CompareBuildsCell;
